import React, { createContext, useState, ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { messages, Locale } from "./i18n";
import { flattenMessages } from "i18n/utils";

interface LanguageContextProps {
  locale: Locale;
  changeLanguage: (lang: Locale) => void;
}

export const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>("es");

  const changeLanguage = (lang: Locale) => {
    setLocale(lang);
  };

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage }}>
      <IntlProvider locale={locale} messages={flattenMessages(messages[locale])}>
        {children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};
